import base64 from '../global/base64.js';
import md5 from '../global/md5.js';
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';
import api from '../api.js'
import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading

const startLoading = () => { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0)'
  })
}
const endLoading = () => { //使用Element loading-close 方法
  loading.close()
}

const fSmApiReq = async (sReqUrl, sApiName, sMethodName, sReqJsonStr, sApiUserPhone, sApiUserId, sApiReqFrom,
  sApiRandomStr, sApiReqOrgAk, sApiReqOrgSk, checkSignType = 'MD5') => {


  let sReqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let sReqJsonBase64 = Base64.encode(sReqJsonStr);

  // 组装签名

  let sApiReqSign = sApiReqOrgSk + sReqJsonBase64 + sReqTime + sApiReqOrgSk;
  sApiReqSign = md5(sApiReqSign);
  sApiReqSign = sApiReqSign.toLowerCase();

  let js = {};
  // API名称
  js['API_NAME'] = sApiName;
  // 请求方法名
  js['METHOD_NAME'] = sMethodName;
  // 请求json BASE64字符串
  js['REQ_JSON_STR'] = sReqJsonBase64;
  // API用户手机号
  js['API_USER_PHONE'] = sApiUserPhone;
  // API用户ID
  js['API_USER_ID'] = sApiUserId || '1001';
  // 请求来源
  js['API_REQ_FROM'] = sApiReqFrom;
  //版本号
  js['API_REQ_VER'] = '';
  // 请求TOKEN
  js['API_REQ_TOKEN'] = sessionStorage.getItem('smSellAdminToken'); //
  // 请求随机字符串
  js['API_RANDOM_STR'] = sApiRandomStr;
  // 请求机构AK
  js['API_REQ_ORG_AK'] = sApiReqOrgAk;
  // 请求签名
  js['API_REQ_SIGN'] = sApiReqSign;
  // 请求时间
  js['API_REQ_TIME'] = sReqTime;
  js['API_REQ_VER'] = 'smSellAdmin';

  js['RANDOM_STR'] = sApiRandomStr;
  js['REQ_JSON'] = sReqJsonBase64;
  js['MCH_ID'] = sApiUserPhone;
  js['USER_ID'] = sApiUserId || '1001';
  js['REQ_IP'] = '127.0.0.1';
  js['REQ_FROM'] = sApiReqFrom;
  js['REQ_VER'] = 'smSellAdmin';
  js['REQ_TIME'] = sReqTime;
  js['REQ_TOKEN'] = sessionStorage.getItem('smSellAdminToken'); //

  let device_id = ''
  console.log(store.state.smSellAdmin.device_id)
  if (api.smCom.fSmIsEmpty(store.state.smSellAdmin.device_id)) {
    function getCurrentCustomTimestamp() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

      return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds.slice(
						      0,
						      2
						    )}`;
    }

    function generateWeb() {
      const prefix = "WEB_";
      const timestamp = getCurrentCustomTimestamp(); // 获取当前时间戳到毫秒
      const randomNum = Math.floor(100 + Math.random() * 900); // 生成3位随机数
      console.log(timestamp, "userOpenId");
      return `${prefix}${timestamp}_${randomNum}`;
    }
    // device_id = generateWeb();
    // uni.$u.vuex('gWx.userOpenId', generateWeb());
    store.commit('device_id', generateWeb())
  }
  js['DEVICE_ID'] = store.state.smSellAdmin.device_id;

  console.log(js)
  if (sApiName == 'smSellAdminApi' || sApiName == 'smSellWgoApi' || sApiName == 'smSellQueryApi') {
    if (api.smCom.fSmIsEmpty(store.state.smSellAdmin.shLoadUrl)) {
      window.location.replace('http://soft.sanmipos.com/smSellAdmin/index.html')
      return {
        // data: {
        result: 'fail',
        msg: '请重新登录'
        // }
      }
    }
    if (sMethodName == 'GET_MALL_INFO' || sMethodName == 'USER_LOGIN') {
      //这两个接口不需要token
    } else {
      if (api.smCom.fSmIsEmpty(sessionStorage.getItem('smSellAdminToken'))) {
        window.location.replace('http://soft.sanmipos.com/smSellAdmin/index.html')
        return {
          // data: {
          result: 'fail',
          msg: '请重新登录'
          // }
        }
      }
    }
    //
  }
  startLoading()
  let res = await axios.post(sReqUrl, js);
  console.log(sReqUrl)
  if (res.data.result != 'sucess' && res.data.msg == 'tokenFail') {
    endLoading()
    window.location.replace('http://soft.sanmipos.com/smSellAdmin/index.html')
    return {
      // data: {
      result: 'fail',
      msg: '请重新登录'
      // }
    }
  }
  endLoading()
  // console.log(res, '总请求')
  if (!isObject(res.data)) {
    return {
      'result': 'fail',
      'msg': res
    };
  }
  return res.data;
};

function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}
//smSell主服务器接口
const fPostToSmSellMainSrvApi = (sMethodName, reqJson = {}, port = '5837', sApiRandomStr) => {
  let sReqUrl;
  // if (window.location.protocol == "https:") {
  sReqUrl = 'https://www.91byk.com/smSellMain/api/smSellApi/';
  // } else {
  //   sReqUrl = `http://8.142.45.98:${port}/api/smSellApi/`;
  // }
  let sApiUserPhone = store.state.smSellAdmin.shPhone || '18957102098'
  let sApiUserId = store.state.smSellAdmin.userId || '1001'
  return fSmApiReq(sReqUrl, 'smSellMainSrvApi', sMethodName, JSON.stringify(reqJson),
    sApiUserPhone, sApiUserId, 'WEB', sApiRandomStr);
};

//smSell后台接口
const fPostToSmSellAdminApi = (sMethodName, reqJson = {}, port = '6837') => {
  console.log(port, 'fPostToSmSellAdminApi====>port')
  let sReqUrl;
  // if (window.location.protocol == "https:") {
  sReqUrl = store.state.smSellAdmin.shLoadUrl + '/api/smSellApi/';
  if (port == '6837') {
    sReqUrl = store.state.smSellAdmin.shLoadUrl + '6/api/smSellApi/';
  }
  // } else {
  //   sReqUrl = `http://${store.state.smSellAdmin.fwqIp}:${port}/api/smSellApi/`;
  // }
  return fSmApiReq(sReqUrl, 'smSellAdminApi', sMethodName, JSON.stringify(reqJson),
    store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB');
  // store.state.smWgoSh.phoneNo

};

//wgo接口
const fPostToSmSellWgoApi = (sMethodName, reqJson = {}, port = '5837') => {
  let sReqUrl;
  // if (window.location.protocol == "https:") {
  sReqUrl = store.state.smSellAdmin.shLoadUrl + '/api/smSellApi/';
  if (port == '6837') {
    sReqUrl = store.state.smSellAdmin.shLoadUrl + '6/api/smSellApi/';
  }
  // } else {
  //   sReqUrl = `http://${ store.state.smSellAdmin.fwqIp }:${port}/api/smSellApi/`;
  // }
  return fSmApiReq(sReqUrl, 'smSellWgoApi', sMethodName, JSON.stringify(reqJson),
    store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB');

};

//smSell查询接口
const fPostToSmSellQueryApi = (sMethodName, reqJson = {}, post = '', url, shPhone, userId, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = store.state.smSellAdmin.shLoadUrl + '/api/smSellApi/';
  } else {
    sReqUrl = 'http://' + store.state.smSellAdmin.fwqIp + ':5835/api/smSellApi/';
  }
  if (post == 'wechat') {
    // sReqUrl = '8.142.45.98' + '/api/smSellApi/';
    sReqUrl = "https://www.91byk.com/smSellMain/api/smSellApi/"
  }
  if (!api.smCom.fSmIsEmpty(post)) {
    // sReqUrl = '8.142.45.98' + '/api/smSellApi/';
    if (window.location.protocol == "https:") {
      sReqUrl = url + '/api/smSellApi/';
    } else {
      sReqUrl = 'http://' + post + ':5835/api/smSellApi/'
    }
  }
  return fSmApiReq(sReqUrl, 'smSellQueryApi', sMethodName, JSON.stringify(reqJson),
    shPhone || store.state.smSellAdmin.shPhone, userId || store.state.smSellAdmin.userId, 'WEB', sApiRandomStr);
};
//支付接口
const fPostToSmPayAggApi = async (sMethodName, reqJson = {}, url, app_id, app_secret) => {
  let sReqUrl = url
  return fSmApiReq(sReqUrl, 'smPayAggApi', sMethodName, JSON.stringify(reqJson),
    app_id, store.state.smSellAdmin.userId, 'WEB', '', app_id, app_secret);
};
// const fPostToSmaxAdminApi = (sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
//   // store.state.smWgoSh.shLoadUrl
//   let sReqUrl = 'http://' + store.state.smSellAdmin.fwqIp + '/smTakeOut/axAdmin';
//   return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
//     store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB', sApiRandomStr);
// };
const fPostToSmTakeOut = (apiName, sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = store.state.smSellAdmin.shLoadUrl + 's/smTakeOut/' + apiName;
  } else {
    sReqUrl = 'http://' + store.state.smSellAdmin.fwqIp + '/smTakeOut/' + apiName; //tkAdmin  tkQry
  }
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB', sApiRandomStr);
};

// const fPostToSmTakeOutTkQryApi = (sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
//   // store.state.smWgoSh.shLoadUrl
//   let sReqUrl = 'http://' + store.state.smSellAdmin.fwqIp + '/smTakeOut/';
//   return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
//     store.state.smSellAdmin.shPhone, store.state.smSellAdmin.userId, 'WEB', sApiRandomStr);

// };

export default {
  fPostToSmSellAdminApi, //smSell后台接口
  fPostToSmSellQueryApi, //smSell查询接口
  fPostToSmSellWgoApi, //wgo接口
  fPostToSmSellMainSrvApi, //smSell主服务器接口
  fPostToSmPayAggApi,
  fPostToSmTakeOut,
  // fPostToSmTakeOutTkQryApi,
  // fPostToSmaxAdminApi
}



//////////////////
// WEBPACK FOOTER
// ./common/api/smSellApi.js
// module id = null
// module chunks = 